import { render, staticRenderFns } from "./AlUploadCard.vue?vue&type=template&id=1b142060&scoped=true"
import script from "./AlUploadCard.vue?vue&type=script&lang=js"
export * from "./AlUploadCard.vue?vue&type=script&lang=js"
import style0 from "./AlUploadCard.vue?vue&type=style&index=0&id=1b142060&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b142060",
  null
  
)

export default component.exports